/* Clean theme behaviors: reveal-on-scroll, product hero, design lineup. */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  window.__ucReady = true;
  if (!reduceMotion && !designMode) root.classList.add('uc-motion');

  /* ---------------- Reveal on scroll ---------------- */

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('[data-reveal]:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion || designMode) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- Money ---------------- */

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Math.round(Number(cents) || 0);
    format = format || '${{amount}}';
    function delimit(n, precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      default: value = delimit(cents, 2, ',', '.');
    }
    var out = format.replace(/\{\{\s*\w+\s*\}\}/, value);
    var tmp = document.createElement('div');
    tmp.innerHTML = out;
    return tmp.textContent;
  }

  /* ---------------- Product hero ---------------- */

  if (!customElements.get('uc-hero')) {
    customElements.define('uc-hero', class extends HTMLElement {
      connectedCallback() {
        var json = this.querySelector('[data-hero-json]');
        if (!json) { this.classList.add('is-ready'); return; }
        this.data = JSON.parse(json.textContent);
        this.variants = this.data.variants || [];
        this.fieldsets = Array.prototype.slice.call(this.querySelectorAll('[data-option]'));
        this.idInput = this.querySelector('[data-variant-input]');
        this.qtyInput = this.querySelector('[data-qty-input]');
        this.atc = this.querySelector('[data-atc]');
        this.atcLabel = this.querySelector('[data-atc-label]');
        this.atcTotal = this.querySelector('[data-atc-total]');
        this.priceEl = this.querySelector('[data-price]');
        this.compareEl = this.querySelector('[data-compare]');
        this.tagEl = this.querySelector('[data-hero-tag]');
        this.img = this.querySelector('img.uc-hero__img');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-slide]'));
        this.slideIndex = Math.max(0, this.slides.findIndex(function (el) { return el.classList.contains('is-active'); }));
        this.countEl = this.querySelector('[data-gallery-count]');
        this.sticky = this.querySelector('[data-sticky]');
        this.stickyPrice = this.querySelector('[data-sticky-price]');
        this.lowEl = this.querySelector('[data-low-stock]');
        this.lowText = this.querySelector('[data-low-stock-text]');
        this.tiers = Array.prototype.slice.call(this.querySelectorAll('[data-bundle] input[type="radio"]'));
        this.qtyFields = Array.prototype.slice.call(this.querySelectorAll('[data-qty-field]'));
        this.offers = (this.data.offers || []).filter(function (o) { return o.buy > 0 && o.get > 0; });
        this.qty = this.clampQty(this.qtyInput ? this.qtyInput.value : 1);

        this.paintSwatches();
        this.querySelectorAll('[data-hero-in]').forEach(function (el) {
          el.style.setProperty('--i', el.getAttribute('data-hero-in'));
        });

        this.addEventListener('change', this.onChange.bind(this));
        this.addEventListener('click', this.onStep.bind(this));
        this.addEventListener('input', this.onQtyInput.bind(this));
        this.update(false);
        this.initSticky();
        this.initGallery();

        var self = this;
        var ready = function () { self.classList.add('is-ready'); };
        requestAnimationFrame(function () { requestAnimationFrame(ready); });
        setTimeout(ready, 500);

        document.addEventListener('uc:select-option', function (e) {
          self.selectOption(e.detail.index, e.detail.value);
        });
      }

      /* Hero image gallery: arrows, swipe, and a "1 / N" counter. */
      initGallery() {
        if (this.slides.length < 2) return;
        var self = this;
        var prev = this.querySelector('[data-gallery-prev]');
        var next = this.querySelector('[data-gallery-next]');
        if (prev) prev.addEventListener('click', function () { self.showSlide(self.slideIndex - 1); });
        if (next) next.addEventListener('click', function () { self.showSlide(self.slideIndex + 1); });
        var frame = this.querySelector('[data-gallery]');
        var startX = null;
        var startY = null;
        frame.addEventListener('touchstart', function (e) {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
        }, { passive: true });
        frame.addEventListener('touchend', function (e) {
          if (startX === null) return;
          var dx = e.changedTouches[0].clientX - startX;
          var dy = e.changedTouches[0].clientY - startY;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) self.showSlide(self.slideIndex + (dx < 0 ? 1 : -1));
          startX = null;
        }, { passive: true });
        this.showSlide(this.slideIndex);
      }

      showSlide(i) {
        var n = this.slides.length;
        if (!n) return;
        this.slideIndex = ((i % n) + n) % n;
        var active = this.slideIndex;
        this.slides.forEach(function (el, idx) {
          var on = idx === active;
          el.classList.toggle('is-active', on);
          if (on) el.removeAttribute('aria-hidden'); else el.setAttribute('aria-hidden', 'true');
        });
        if (this.countEl) this.countEl.textContent = (active + 1) + ' / ' + n;
      }

      paintSwatches() {
        var map = {};
        (this.data.swatches || []).forEach(function (line) {
          var parts = String(line).split(':');
          if (parts.length >= 2) map[parts[0].trim().toLowerCase()] = parts.slice(1).join(':').trim();
        });
        this.querySelectorAll('[data-swatch]').forEach(function (el) {
          var c = map[el.getAttribute('data-swatch').toLowerCase()];
          if (c) el.style.setProperty('--sw', c);
        });
      }

      selected() {
        return this.fieldsets.map(function (fs) {
          var input = fs.querySelector('input:checked');
          return input ? input.value : null;
        });
      }

      onChange(e) {
        if (e.target.matches('[data-qty-field]')) {
          this.setQty(e.target.value);
          return;
        }
        if (!e.target.matches('input[type="radio"]')) return;
        if (e.target.closest('[data-bundle]')) {
          this.setQty(e.target.value);
          return;
        }
        this.update(true);
      }

      clampQty(n) {
        n = parseInt(n, 10);
        if (!isFinite(n) || n < 1) n = 1;
        return Math.min(n, 99);
      }

      /* One quantity for the whole hero: stepper(s), tier highlight and the form's hidden field. */
      setQty(n) {
        this.qty = this.clampQty(n);
        this.update(false);
      }

      onStep(e) {
        var btn = e.target.closest('[data-qty-step]');
        if (!btn || !this.contains(btn)) return;
        this.setQty(this.qty + parseInt(btn.getAttribute('data-qty-step'), 10));
      }

      onQtyInput(e) {
        if (!e.target.matches('[data-qty-field]')) return;
        // Apply valid numbers while typing; blanks are settled on change.
        if (e.target.value === '') return;
        var n = parseInt(e.target.value, 10);
        if (isFinite(n) && n >= 1) {
          this.qty = this.clampQty(n);
          this.update(false, e.target);
        }
      }

      /* Mirrors Shopify's automatic Buy X Get Y: offers don't stack, the better one wins. */
      estimate(qty, price) {
        var full = qty * price;
        var best = 0;
        this.offers.forEach(function (o) {
          var saved = Math.floor(qty / (o.buy + o.get)) * o.get * price * (o.pct / 100);
          if (saved > best) best = saved;
        });
        return { full: full, total: Math.round(full - best) };
      }

      selectOption(index, value) {
        var fs = this.fieldsets[index];
        if (!fs) return;
        var input = Array.prototype.find.call(fs.querySelectorAll('input'), function (i) { return i.value === value; });
        if (input) {
          input.checked = true;
          this.update(true);
        }
        var top = this.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      /* Cascade: each option's values are filtered by the selections before it. */
      resolve() {
        var sel = this.selected();
        var variants = this.variants;
        var self = this;
        this.fieldsets.forEach(function (fs, i) {
          var prior = sel.slice(0, i);
          var matching = variants.filter(function (v) {
            for (var j = 0; j < prior.length; j++) if (v.options[j] !== prior[j]) return false;
            return true;
          });
          var inputs = Array.prototype.slice.call(fs.querySelectorAll('input'));
          var exists = 0;
          inputs.forEach(function (input) {
            var withValue = matching.filter(function (v) { return v.options[i] === input.value; });
            var chip = input.closest('.uc-chip');
            var any = withValue.length > 0;
            var available = withValue.some(function (v) { return v.available; });
            chip.classList.toggle('is-hidden', !any);
            chip.classList.toggle('is-unavailable', any && !available);
            input.disabled = !any;
            if (any) exists++;
          });
          var current = fs.querySelector('input:checked');
          if (!current || current.disabled) {
            var fallback = inputs.find(function (input) {
              return !input.disabled && !input.closest('.uc-chip').classList.contains('is-unavailable');
            }) || inputs.find(function (input) { return !input.disabled; });
            if (fallback) fallback.checked = true;
            sel[i] = fallback ? fallback.value : null;
          }
          // Collapse an option to its label when only one value applies.
          fs.classList.toggle('is-single', exists <= 1);
          fs.querySelector('.uc-opt__values').hidden = exists <= 1;
          var label = fs.querySelector('[data-option-value]');
          if (label) label.textContent = sel[i] || '';
        });
        return variants.find(function (v) {
          return v.options.every(function (o, idx) { return o === sel[idx]; });
        });
      }

      update(fromUser, typingField) {
        var v = this.fieldsets.length ? this.resolve() : this.variants[0];
        var fmt = this.data.moneyFormat;
        var qty = this.qty;
        var self = this;

        if (this.qtyInput) this.qtyInput.value = qty;
        this.qtyFields.forEach(function (f) {
          if (f !== typingField) f.value = qty;
          var minus = f.parentNode.querySelector('[data-qty-step="-1"]');
          if (minus) minus.disabled = qty <= 1;
          var plus = f.parentNode.querySelector('[data-qty-step="1"]');
          if (plus) plus.disabled = qty >= 99;
        });
        this.tiers.forEach(function (r) { r.checked = parseInt(r.value, 10) === qty; });

        // Tier totals
        if (v) {
          // Crossed-out price uses the compare-at price when the variant has one.
          var unitWas = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : v.price;
          this.tiers.forEach(function (r) {
            var q = parseInt(r.value, 10) || 1;
            var est = self.estimate(q, v.price);
            var was = q * unitWas;
            var out = r.closest('.uc-tier').querySelector('[data-tier-total]');
            if (out) out.innerHTML = formatMoney(est.total, fmt) + (est.total < was ? '<s>' + formatMoney(was, fmt) + '</s>' : '');
          });
        }

        if (!v) {
          this.atc.disabled = true;
          this.atcLabel.textContent = this.data.unavailableLabel;
          this.atcTotal.textContent = '';
          return;
        }

        this.idInput.value = v.id;
        // Headline price follows the selected quantity, like the tier totals.
        this.priceEl.textContent = formatMoney(this.estimate(qty, v.price).total, fmt);
        if (this.compareEl) {
          var onSale = v.compare_at_price && v.compare_at_price > v.price;
          this.compareEl.hidden = !onSale;
          if (onSale) this.compareEl.textContent = formatMoney(qty * v.compare_at_price, fmt);
          if (this.tagEl) this.tagEl.hidden = !onSale;
        }

        // Low stock badge: real count for tracked variants, merchant's text otherwise.
        if (this.lowEl) {
          if (typeof v.inv === 'number') {
            this.lowEl.hidden = v.inv <= 0;
            this.lowText.textContent = 'Only ' + v.inv + ' left';
          } else {
            this.lowEl.hidden = false;
            this.lowText.textContent = this.data.lowStockText;
          }
        }

        var lineTotal = this.estimate(qty, v.price).total;
        this.atc.disabled = !v.available;
        this.atc.removeAttribute('aria-disabled');
        this.atcLabel.textContent = v.available ? this.data.addLabel : this.data.soldOutLabel;
        this.atcTotal.textContent = v.available ? formatMoney(lineTotal, fmt) : '';
        if (this.stickyPrice) this.stickyPrice.textContent = formatMoney(lineTotal, fmt) + (qty > 1 ? ' · ' + qty + ' items' : '');

        // Media swap: jump to the variant's photo in the gallery, or swap the single image.
        if (fromUser && this.slides.length > 1 && v.featured_media && v.featured_media.id) {
          var target = this.slides.findIndex(function (el) { return el.getAttribute('data-media-id') === String(v.featured_media.id); });
          if (target > -1) this.showSlide(target);
        } else if (fromUser && this.img && v.featured_media && v.featured_media.preview_image) {
          var src = v.featured_media.preview_image.src;
          if (src && this.img.dataset.current !== src) {
            this.img.dataset.current = src;
            var next = new Image();
            var url = /[?&]width=/.test(src) ? src : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1600';
            next.onload = function () {
              self.img.classList.add('is-swapping');
              setTimeout(function () {
                self.img.removeAttribute('srcset');
                self.img.src = url;
                self.img.alt = v.featured_media.alt || v.name || '';
                requestAnimationFrame(function () { self.img.classList.remove('is-swapping'); });
              }, reduceMotion ? 0 : 220);
            };
            next.src = url;
          }
        }

      }

      initSticky() {
        if (!this.sticky || !this.atc) return;
        var sticky = this.sticky;
        var form = this.querySelector('form');
        var btn = sticky.querySelector('[data-sticky-btn]');
        btn.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(); else form.querySelector('[type="submit"]').click();
        });
        if (!('IntersectionObserver' in window)) return;
        var heroVisible = true;
        var footerVisible = false;
        function sync() {
          var show = !heroVisible && !footerVisible;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          btn.tabIndex = show ? 0 : -1;
        }
        new IntersectionObserver(function (entries) {
          heroVisible = entries[0].isIntersecting;
          sync();
        }).observe(this.atc);
        var footer = document.querySelector('.footer');
        if (footer) {
          new IntersectionObserver(function (entries) {
            footerVisible = entries[0].isIntersecting;
            sync();
          }).observe(footer);
        }
      }
    });
  }

  /* ---------------- Lineup ---------------- */

  function initLineup(scope) {
    (scope || document).querySelectorAll('.uc-lineup').forEach(function (wrap) {
      if (wrap.dataset.ucBound) return;
      wrap.dataset.ucBound = '1';
      var track = wrap.querySelector('[data-lineup-track]');
      var prev = wrap.querySelector('[data-lineup-prev]');
      var next = wrap.querySelector('[data-lineup-next]');
      if (!track) return;
      function step() {
        var item = track.querySelector('.uc-lineup__item');
        return item ? item.getBoundingClientRect().width + 20 : 300;
      }
      function sync() {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft < 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      sync();
      wrap.addEventListener('click', function (e) {
        var card = e.target.closest('[data-select-option]');
        if (!card) return;
        document.dispatchEvent(new CustomEvent('uc:select-option', {
          detail: { index: parseInt(card.getAttribute('data-select-option'), 10), value: card.getAttribute('data-value') }
        }));
      });
    });
  }

  function init(scope) {
    initReveal(scope);
    initLineup(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
